import { Controller } from "stimulus"

// #1263 (Sam, 20-10-2026): Compact | Normaal | Uitgebreid in het rooster. De
// keuze zet data-dichtheid op het rooster (de uurhoogte in appointments/stijl)
// en wordt per gebruiker in deze browser onthouden. Kan de browser niets
// opslaan (privévenster), dan geldt de keuze tot de volgende pagina. Zonder
// JavaScript blijven de knoppen verborgen en is het rooster Normaal.
//
// #1977: op de telefoon opent het rooster in de dag (Sam: "dat lijkt me een
// hele goede"). Kiest de gebruiker zelf Week, Dag of Maand, dan onthoudt deze
// browser dat en blijft die keuze gelden. Een weergave in de url gaat altijd
// voor; zonder JavaScript is het de week.
//
// Daarnaast sluit dit het menu Filters bij een klik ernaast.
const DICHTHEDEN = ["compact", "normaal", "uitgebreid"]
const TELEFOON = "(max-width: 767px), (pointer: coarse) and (max-height: 500px)"

export default class extends Controller {
  static targets = ["knoppen", "knop", "filtermenu"]
  static values = { gebruiker: String, gekozen: Boolean }

  connect() {
    this.zet(this.lees() || "normaal")
    if (this.hasKnoppenTarget) this.knoppenTarget.hidden = false
    this.weergaveOpTelefoon()
  }

  weergaveOpTelefoon() {
    if (this.gekozenValue || !window.matchMedia(TELEFOON).matches) return

    const weergave = this.leesWeergave() || "dag"
    if (weergave === this.element.dataset.weergave) return

    const knop = this.element.querySelector(`[data-weergave-knop="${weergave}"]`)
    if (!knop) return
    if (window.Turbo) window.Turbo.visit(knop.href, { action: "replace" })
    else window.location.replace(knop.href)
  }

  onthoud(event) {
    try {
      window.localStorage.setItem(this.weergaveSleutel, event.currentTarget.dataset.weergaveKnop)
    } catch (e) {
      // niet opslaan kan: de keuze geldt dan alleen op deze pagina
    }
  }

  buitenFilters(event) {
    if (!this.hasFiltermenuTarget || this.filtermenuTarget.contains(event.target)) return
    this.filtermenuTarget.open = false
  }

  kies(event) {
    const dichtheid = event.currentTarget.dataset.dichtheid
    if (!DICHTHEDEN.includes(dichtheid)) return
    this.zet(dichtheid)
    this.bewaar(dichtheid)
  }

  zet(dichtheid) {
    this.element.dataset.dichtheid = dichtheid
    this.knopTargets.forEach((knop) => {
      const actief = knop.dataset.dichtheid === dichtheid
      knop.classList.toggle("is-actief", actief)
      knop.setAttribute("aria-pressed", actief ? "true" : "false")
    })
  }

  get sleutel() {
    return `cc-rooster-dichtheid-${this.gebruikerValue || "ik"}`
  }

  get weergaveSleutel() {
    return `cc-rooster-weergave-${this.gebruikerValue || "ik"}`
  }

  leesWeergave() {
    try {
      return window.localStorage.getItem(this.weergaveSleutel)
    } catch (e) {
      return null
    }
  }

  lees() {
    try {
      const waarde = window.localStorage.getItem(this.sleutel)
      return DICHTHEDEN.includes(waarde) ? waarde : null
    } catch (e) {
      return null
    }
  }

  bewaar(dichtheid) {
    try {
      window.localStorage.setItem(this.sleutel, dichtheid)
    } catch (e) {
      // niet opslaan kan: de keuze geldt dan alleen op deze pagina
    }
  }
}
